import { Paper } from '@mui/material';
import React from 'react';

export default class RefExampleDestination extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      text: props.testProp,
      counter: 0,
    };
  }

  componentDidMount() {}

  clear() {
    this.setState({
      text: '-',
      counter: 0,
    });
  }

  render() {
    return (
      <Paper
        elevation={6}
        className='border p-1 m-1'
      >
        <h2>Destination component</h2>
        <div>This is the RefExampleDestination component.</div>
        <div>props.testProps mapped to state.text + state.counter:</div>
        <div className='h4'>{this.state.text + ' (' + this.state.counter + ')'}</div>
      </Paper>
    );
  }
}
